import LegalPageLayout from './LegalPageLayout'
import { LEGAL_DOCS } from '../../constants/legalContent'

export default function AcceptableUsePolicyPage() {
  const doc = LEGAL_DOCS.acceptableUsePolicy
  return (
    <LegalPageLayout
      pageTitle={doc.pageTitle}
      effectiveDate={doc.effectiveDate}
      sections={doc.sections}
    />
  )
}

